import { useCallback, useState } from 'react';
const PATHNAME_KEY = 'pathname';
const SEARCH_KEY = 'search';
const HASH_KEY = 'hash';
const readRequestedLocation = (excludedPaths) => {
    const pathname = sessionStorage.getItem(PATHNAME_KEY);
    const search = sessionStorage.getItem(SEARCH_KEY);
    const hash = sessionStorage.getItem(HASH_KEY);
    if (!pathname || pathname === '/' || excludedPaths.includes(pathname)) {
        return undefined;
    }
    return [pathname, search, hash].join('');
};
export const useRequestedLocation = (excludedPaths = []) => {
    const [requestedLocation, setLocation] = useState(() => readRequestedLocation(excludedPaths));
    const setRequestedLocation = useCallback((location) => {
        sessionStorage.setItem(PATHNAME_KEY, location.pathname);
        sessionStorage.setItem(SEARCH_KEY, location.search);
        sessionStorage.setItem(HASH_KEY, location.hash);
    }, []);
    const clearRequestedLocation = useCallback(() => {
        sessionStorage.removeItem(PATHNAME_KEY);
        sessionStorage.removeItem(SEARCH_KEY);
        sessionStorage.removeItem(HASH_KEY);
        setLocation(undefined);
    }, []);
    return { requestedLocation, setRequestedLocation, clearRequestedLocation };
};
